module.exports = __webpack_public_path__ + "img/honey.db240f98.png";